import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'

interface PerDiemProps extends WithStyles<typeof styles> {
	perDiem: string
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const PerDiem: React.FC<PerDiemProps> = (props: PerDiemProps) => {
	const { classes, perDiem, onChange } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Per Diem&#58;
			</Grid>
			<Grid item={true} xs={12} sm={4} md={3} className={classes.dropdownLabel}>
				<TextField
					name="perDiem"
					select={true}
					className={classes.dropdown}
					required={false}
					value={perDiem}
					onChange={onChange}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.select,
						},
					}}
					margin="dense"
					variant="outlined"
				>
					<option value=""/>
					{['Yes'].map((option: string) => (
						<option key={option} value={option}>
							{option}
						</option>
					))}
				</TextField>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
		input: {},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
	})

export default withStyles(styles)(PerDiem)
